import { GridColDef } from "@mui/x-data-grid-pro";
import { IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import dayjs from "dayjs";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GenerateEntregaPesquisaSatisfacaoColumnDefinition
 */

type Props = {
  onActionEditar: (idEntregaPesquisa: number, openNewTab: boolean) => void;
  onActionDelete: (idEntregaPesquisa: number, openModal: boolean) => void;
};

export const GenerateEntregaPesquisaSatisfacaoColumnDefinition = ({
  onActionEditar,
  onActionDelete,
}: Props): GridColDef[] => {

  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 1:
        return "Finalizada";
      case 0:
        return "Em aberto";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 1:
        return "green";
      case 0:
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 1:
        return "Finalizada";
      case 0:
        return "Em aberto";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 110,
      width: 110,
      sortable: false,
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(value)}
            color={computeItemStatusColor(value)}
            description={computeItemStatusDescription(value)}
          />
        </div>
      )
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Pesquisa",
      flex: 1,
      minWidth: 80,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) => <span>{value}</span>
    },
    {
      field: "observacao",
      filterable: false,
      headerName: "Observações",
      flex: 1,
      minWidth: 80,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) => <span>{value}</span>
    },
    {
      field: "data",
      filterable: false,
      headerName: "Data",
      width: 100,
      minWidth: 100,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) => <span>{value ? dayjs.utc(value).local().format("DD/MM/YYYY") : ""}</span>
    },
    {
      field: "indiceSatisfacao",
      filterable: false,
      headerName: "Índice de Satisfação",
      width: 100,
      minWidth: 100,
      sortable: false,
      align: 'left',
      renderCell: ({ value }) => (
        <span>
          {
            new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 2 }).format(value ?? 0)
          }
        </span>
      )
    },
    {
      field: 'idEntregaPesquisa',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true); }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}